<template>
  <b-card
      title="مدیریت شهرها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 ml-1"
                  variant="primary"
                  @click="addCity()"
              >
                جدید
              </b-button>
              <b-button
                  variant="success"
                  class="mb-1 mr-auto ml-1"
                  @click="clearCache"
              >
                بروزرسانی
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                @click="updateCity(data.item)"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Origin)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(Destination)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(Duration)="data">
            {{ data.value.split(':')[0] + ':' + data.value.split(':')[1] }}
          </template>

          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <b-link @click="updateCity(data.item)">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>

              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
        v-model="showModal"
        v-if="showModal"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="جزئیات مسیر"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
    >
      <b-col md="12">
        <b-form-group
            label="مبدا"
            label-for="OriginId"
        >
          <z-city v-model="row.OriginId" :clearable="false"/>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
            label="مقصد"
            label-for="DestinationId"
        >
          <z-city v-model="row.DestinationId" :clearable="false"/>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
            label="مدت زمان"
            label-for="Duration"
        >
          <date-picker
              type="time"
              v-model="duration"
format="YYYY-MM-DD HH:mm"
              display-format="HH:mm"
          />
        </b-form-group>
      </b-col>
    </b-modal>
  </b-card>
</template>

<script>
import ZCity from "@/tools/city.vue";

export default {
  name: 'Route',
  components: {ZCity},
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      duration: null,
      filterOptions: {
        Title: null,
        Page: 1,
        Type: 0,
      },
      showModal: false,
      row: {},
      time: '08:03',
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Origin',
          label: 'مبدا',
        },
        {
          key: 'Destination',
          label: 'مقصد',
        },
        {
          key: 'Duration',
          label: 'مدت زمان',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', {key: this.$options.name, value: this.filterOptions})

      this.$http.post(
          this.$api.route.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
          this.$api.route.clearcache, null,
      )
          .then(res => {
            this.update()
          })
    },
    save() {
      let url = this.$api.route.add
      if (this.row.Id) {
        url = this.$api.route.update
      }

      this.row.Duration = this.duration.split(' ')[1]

      this.$http.post(
          url, this.row,
      )
          .then(() => {
            this.update()
          })
          .catch(() => {
            this.showModal = true
          })
    },
    addCity() {
      this.row = {Duration: null, DestinationId: null, OriginId: null}
      this.duration = null
      this.showModal = true
    },
    updateCity(row) {
      this.row = {Id: row.Id, Duration: row.Duration, OriginId: row.Origin.Id, DestinationId: row.Destination.Id}

      this.duration = '2024/01/01 ' + row.Duration
      this.showModal = true
    },
    remove(id) {
      this.removeRow(this.$api.route.remove, 'Id', id)
    },
  },
}
</script>

<style scoped>

</style>